export function parseLocalDate(dateValue) {
  if (!dateValue) return null;
  if (dateValue instanceof Date) {
    return Number.isNaN(dateValue.getTime()) ? null : dateValue;
  }

  const str = String(dateValue).trim();
  const match = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) {
    const year = Number(match[1]);
    const month = Number(match[2]) - 1;
    const day = Number(match[3]);
    return new Date(year, month, day);
  }

  const parsed = new Date(str);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function coerceToInstant(dateValue) {
  if (!dateValue) return null;
  if (dateValue instanceof Date) {
    return Number.isNaN(dateValue.getTime()) ? null : dateValue;
  }
  if (typeof dateValue.toDate === 'function') {
    const converted = dateValue.toDate();
    return converted instanceof Date && !Number.isNaN(converted.getTime()) ? converted : null;
  }
  if (typeof dateValue === 'object' && typeof dateValue.seconds === 'number') {
    const converted = new Date(
      dateValue.seconds * 1000 + (dateValue.nanoseconds || 0) / 1e6
    );
    return Number.isNaN(converted.getTime()) ? null : converted;
  }

  const str = String(dateValue).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
    return parseLocalDate(str);
  }

  const parsed = new Date(str);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatRentalDate(dateValue) {
  const date = dateValue instanceof Date ? dateValue : parseLocalDate(dateValue);
  if (!date || Number.isNaN(date.getTime())) return '—';
  const day = String(date.getDate()).padStart(2, '0');
  const month = date.toLocaleDateString('en-US', { month: 'short' });
  const year = String(date.getFullYear()).slice(-2);
  return `${day} ${month} ${year}`;
}

export function formatRentalDateRange(startDate, endDate) {
  return `${formatRentalDate(startDate)} – ${formatRentalDate(endDate)}`;
}

export function formatMessageTimestamp(timestamp) {
  const date = coerceToInstant(timestamp);
  if (!date) return '';
  const timePart = date.toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
  });
  return `${formatRentalDate(date)} ${timePart}`;
}

const ISO_DATE_IN_TEXT_PATTERN = /\b(\d{4}-\d{2}-\d{2})\b/g;

export function formatDatesInMessageText(text) {
  if (!text || typeof text !== 'string') return text;
  return text.replace(ISO_DATE_IN_TEXT_PATTERN, (match) => formatRentalDate(match));
}

export function toLocalDateInputValue(dateValue) {
  const date = parseLocalDate(dateValue);
  if (!date) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}